import { Collapse, CollapseProps } from "antd";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import s from "./FiltersPopOverContent.module.scss";
type PropType = {
  setFilter: (filter: {
    all: boolean;
    pending: boolean;
    approved: boolean;
    rejected: boolean;
  }) => void;
  filter: {
    all: boolean;
    pending: boolean;
    approved: boolean;
    rejected: boolean;
  };
};
function FiltersPopOverContent({ filter, setFilter }: PropType) {
  const [activeKey, setActiveKey] = useState<string>();

  const [filterDraft, setFilterDraft] = useState<{
    all: boolean;
    pending: boolean;
    approved: boolean;
    rejected: boolean;
  }>({
    all: true,
    approved: false,
    pending: false,
    rejected: false,
  });

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Status",
      children: (
        <div className={clsx(s.options, { [s.active]: activeKey === "1" })}>
          <p
            className={clsx(s.checkboxOption, {
              [s.active]: filterDraft?.all,
            })}
            onClick={() =>
              setFilterDraft((prev) => ({
                all: !prev.all,
                approved: false,
                pending: false,
                rejected: false,
              }))
            }
          >
            All
          </p>
          <p
            className={clsx(s.checkboxOption, {
              [s.active]: filterDraft.approved,
            })}
            onClick={() =>
              setFilterDraft((prev) => ({
                all: false,
                approved: !prev.approved,
                pending: false,
                rejected: false,
              }))
            }
          >
            Approved
          </p>
          <p
            className={clsx(s.checkboxOption, {
              [s.active]: filterDraft.pending,
            })}
            onClick={() =>
              setFilterDraft((prev) => ({
                pending: !prev.pending,
                all: false,
                approved: false,
                rejected: false,
              }))
            }
          >
            Pending
          </p>
          <p
            className={clsx(s.checkboxOption, {
              [s.active]: filterDraft.rejected,
            })}
            onClick={() =>
              setFilterDraft((prev) => ({
                all: false,
                rejected: !prev.rejected,
                approved: false,
                pending: false,
              }))
            }
          >
            Rejected
          </p>
        </div>
      ),
    },
  ];
  const handleRest = () => {
    setFilterDraft({
      all: true,
      approved: false,
      pending: false,
      rejected: false,
    });

    setFilter({
      all: true,
      approved: false,
      pending: false,
      rejected: false,
    });
  };
  const handleApply = () => {
    setFilter(filterDraft);
  };
  const onChange = (key: string | string[]) => {
    if (Array.isArray(key)) {
      // collapse closed (empty array), reset state
      setActiveKey(key[0]);
    } else {
      setActiveKey(key);
    }
  };
  useEffect(() => {
    setFilterDraft(filter);
  }, [filter]);
  return (
    <div className={s.wrapper}>
      <span className={s.title}>Filters</span>{" "}
      <Collapse items={items} accordion ghost onChange={onChange} />
      <div className={s.btnWrapper}>
        <button className={s.resetBtn} onClick={handleRest}>
          Reset
        </button>
        <button className={s.applyBtn} onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
}

export default FiltersPopOverContent;
